export default __webpack_public_path__ + "static/media/island_6_with_objects.9d2ae945.png";